module.exports = __webpack_public_path__ + "assets/img/inverter.708da3bf.png";